module.exports = ".circleBase {\n    border-radius: 50%;\n}\n\n.type1 {\n    width: 200px;\n    height: 200px;\n    background: yellow;\n    border: 3px solid red;\n}\n\n.type2 {\n    width: 50px;\n    height: 50px;\n    background: #ccc;\n    border: 3px solid #000;\n}\n\n.type3 {\n    width: 500px;\n    height: 500px;\n    background: aqua;\n    border: 30px solid blue;\n}\n\n@media screen and (max-width: 768px) {\n    #pop-up {\n      display: none;\n    }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = ./src/app/home/home.component.css
// module chunks = main